import { render, staticRenderFns } from "./UserGroupDetail.vue?vue&type=template&id=b641ef8c&scoped=true"
import script from "./UserGroupDetail.vue?vue&type=script&lang=js"
export * from "./UserGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./UserGroupDetail.vue?vue&type=style&index=0&id=b641ef8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b641ef8c",
  null
  
)

export default component.exports